import InputFlexBox from 'components/container/InputFlexBox';
import addBtnIcon from 'utils/icon/icon_add-circle-blue.svg';
import DefaultInput from 'components/input/DefaultInput';
import ImageSelect from 'components/select/ImageSelect';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { IImagePropsList } from 'utils/types/common';
import { ILang, ICoupon, IProductLangProps } from 'utils/types/saleTypes';
import { useTranslation } from 'react-i18next';
import { Image, Upload } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import PrimaryButton from '../../../components/button/PrimaryButton';
import uploadIcon from '../../../utils/icon/icon_upload-image-black.svg';
import cloudIcon from '../../../utils/icon/icon_cloud-upload-image-black.svg';
import plusButtonIcon from '../../../utils/icon/icon_plus-blue.svg';
import { Trash } from 'iconsax-react';
import { storyApi } from '../../../apis/story/storyApis';
import { productApis } from '../../../apis/package/productApis';
import {
  IProjectDetail,
  ISupportLanguage,
} from '../../../utils/types/storyTypes';
import SelectBox from '../../../components/SelectBox';
import { setStoryName } from '../../../store/slices/breadcumbSlice';
import {
  showApiSuccessMessage,
  showStringErrorMessage,
} from '../../../utils/helper/message';
/**
 * * 판매 - 인앱 상점 관리 - 등록 & 수정 다국어 폼
 */

interface IProps {
  product: ICoupon;
  setProduct: React.Dispatch<React.SetStateAction<ICoupon>>;
}

const InAppLocalizingForm: React.FC<IProps> = ({ product, setProduct }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const [supportLangList, setSupportLangList] = useState<ISupportLanguage[]>(
    [],
  );

  const fetchLang = async () => {
    const langRes = await storyApi.supportLang();
    setSupportLangList(langRes);
  };

  useEffect(() => {
    fetchLang();
  }, []);

  const handleInputChange = (e) => {
    const newProduct = { ...product };
    const { id, value, name } = e.target as {
      id: string;
      value: string;
      name: string;
    };
    newProduct.langs = newProduct.langs?.map((v) =>
      v.lang === id ? { ...v, [name]: value } : v,
    );
    setProduct(newProduct);
  };

  const handleAddLang = () => {
    const newLang: ILang = {
      id: 0,
      lang: '',
      title: '',
      banner_url: '',
      banner_key: '',
      bucket: '',
      price: null,
    };

    setProduct((prevProduct) => ({
      ...prevProduct,
      langs: [...(prevProduct.langs || []), newLang],
    }));
  };

  const handleRemoveLang = async (lang: string, id: number) => {
    if (window.confirm('Are you sure you want to remove this language?')) {
      await productApis.deleteProductLang(
        product.project_id,
        Number(product.master_id),
        id,
      );
      const newProduct = { ...product };
      newProduct.langs = newProduct.langs?.filter((v) => v.lang !== lang);
      setProduct(newProduct);
    }
  };

  const props = {
    name: 'file',
    action: '',
    showUploadList: false,
    accept: 'image/png, image/jpeg',
    async onChange(info) {
      if (info.file.status !== 'uploading') {
        // console.log('uploading ===>', info.file, info.fileList);
      }
      if (info.file.status === 'done') {
      } else if (info.file.status === 'error') {
        console.log('failed ===>', info.file);
      }
    },
  };

  const uploadBanner = async (options, lang: ILang) => {
    const { file, onSuccess, onError } = options;
    const isPNG = file.type === 'image/png';
    const isJPG = file.type === 'image/jpeg';

    // showApiSuccessMessage('8MB  이상의 파일을 업로드 할 수 없습니다');
    // return;

    if (!isPNG && !isJPG) {
      showStringErrorMessage('파일 형식이 올바르지 않습니다.');
      return;
    }

    if (file.size > 8000000) {
      showStringErrorMessage('8MB  이상의 파일을 업로드 할 수 없습니다');
      return;
    }

    if (isPNG || isJPG) {
      setLoading(true);
      try {
        const res = await productApis.uploadProductBanner(
          product.project_id,
          Number(product.master_id),
          lang.id,
          file,
        );
        const newProduct = { ...product };
        newProduct.langs = newProduct.langs?.map((v) =>
          v.lang === lang.lang ? { ...v, banner_url: res.banner_url } : v,
        );
        setProduct(newProduct);
        showApiSuccessMessage('이미지가 업로드되었습니다.');
        onSuccess('ok');
      } catch (err) {
        showStringErrorMessage('이미지 업로드에 실패했습니다.');
        console.log('Error', err);
        onError(err);
      } finally {
        setLoading(false);
      }
    }
  };

  const canAddLangList = supportLangList
    .filter((v) => !product.langs?.map((v) => v.lang).includes(v.code))
    .map((v, i) => {
      return {
        value: v.code,
        label: v.code_name,
      };
    });

  return (
    <LangContainer>
      {product.langs?.map((lang, i) => (
        <div className='section_input'>
          {lang.lang ? (
            <>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <PrimaryButton
                  text={t('buttons.remove')}
                  height='40px'
                  width='fit-content'
                  bgColor='#ffffff'
                  textColor={theme.colors.red_500}
                  fontWeight={theme.fontWeights.medium}
                  fontSize={theme.fontSizes.normal}
                  border={`1px solid ${theme.colors.gray_6}`}
                  rounded='6px'
                  hoverBgColor={theme.colors.gray_6}
                  activeBgColor={theme.colors.gray_6}
                  selectedBgColor={theme.colors.gray_6}
                  loading={loading}
                  onClick={() => handleRemoveLang(lang.lang, lang.id)}
                  LeftPlaceHolder={<Trash size='24' />}
                />
              </div>

              <div style={{ padding: '10px 0' }}></div>
              <DefaultInput
                title={t('ifYouID.form.title')}
                name='title'
                id={`${lang.lang}`}
                value={lang.title}
                codeName={lang.lang}
                onChange={handleInputChange}
                localizing
                maxLength={60}
                top='true'
                style={{
                  marginLeft: '0.5rem',
                }}
              />

              <DefaultInput
                title={'가격'}
                name='price'
                id={`${lang.lang}`}
                value={lang.price ? lang.price : ''}
                onChange={handleInputChange}
                type='number'
                top='true'
                style={{
                  marginLeft: '0.2rem',
                }}
              />

              <div className='image_container'>
                <label className='title_label'>{t('ifYouID.form.image')}</label>
                <>
                  <UploadWrapper>
                    <UploadContentWrapper>
                      <div>
                        {loading ? (
                          <div className='flex-wrap icon'>
                            <LoadingOutlined style={{ fontSize: '50px' }} />
                          </div>
                        ) : lang?.banner_url ? (
                          <Image
                            src={lang!.banner_url}
                            alt={`icon`}
                            className='icon'
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                    </UploadContentWrapper>
                    {!loading && (
                      <div className='uploadTotalWrap'>
                        <Upload
                          {...props}
                          maxCount={1}
                          customRequest={(options) =>
                            uploadBanner(options, lang)
                          }
                        >
                          {lang?.banner_url ? (
                            <div style={{ marginLeft: 24 }}>
                              <PrimaryButton
                                text={t('buttons.replaceImage')}
                                height='40px'
                                width='fit-content'
                                bgColor='#ffffff'
                                textColor={theme.colors.dark_400}
                                fontWeight={theme.fontWeights.medium}
                                fontSize={theme.fontSizes.normal}
                                border={`1px solid ${theme.colors.gray_6}`}
                                rounded='6px'
                                hoverBgColor={theme.colors.gray_6}
                                activeBgColor={theme.colors.gray_6}
                                selectedBgColor={theme.colors.gray_6}
                                loading={loading}
                                LeftPlaceHolder={
                                  <img src={uploadIcon} alt='upload' />
                                }
                              />
                              <p className='turText'>
                                {t('updateStory.form.required')}
                              </p>
                            </div>
                          ) : (
                            <>
                              <div className='emptyImage'>
                                <img src={cloudIcon} alt='upload cloud' />
                                <p className='emptyImageText'>
                                  {t('updateStory.form.placeholder')}
                                </p>
                                <img src={plusButtonIcon} alt='plus icon' />
                              </div>
                              <p className='turText'>
                                {t('updateStory.form.required')}
                              </p>
                            </>
                          )}
                        </Upload>
                      </div>
                    )}
                  </UploadWrapper>
                </>
              </div>
            </>
          ) : (
            <>
              <div>
                <p className='title'>{t('updateStory.form.language')}</p>
                <SelectBox
                  value={lang.lang}
                  onChange={async (value: string) => {
                    const productLang: ILang = {
                      id: 0,
                      lang: value,
                      title: '',
                      banner_url: '',
                      banner_key: '',
                      bucket: '',
                      price: null,
                    };

                    const res = await productApis.createProductLang(
                      product.project_id,
                      Number(product.master_id),
                      productLang,
                    );
                    if (res) {
                      console.log(res.id);
                      const newProduct = { ...product };
                      newProduct.langs = newProduct.langs?.map((v) =>
                        v.lang === lang.lang
                          ? { ...v, lang: value, id: res.id }
                          : v,
                      );
                      setProduct(newProduct);
                    }
                  }}
                  options={canAddLangList}
                />
              </div>
            </>
          )}
        </div>
      ))}

      {canAddLangList.length > 0 && (
        <AddButton onClick={handleAddLang}>
          <img src={addBtnIcon} alt='add' />
          <p>Create new product for each language</p>
        </AddButton>
      )}
    </LangContainer>
  );
};

export default InAppLocalizingForm;

const LangContainer = styled.div`
  .section_input {
    margin-bottom: 4rem;
    border-bottom: 1px solid rgba(217, 222, 227, 0.5);
    padding-bottom: 2.5rem;
  }

  .image_container {
    width: 100%;

    .title_label {
      color: ${theme.colors.blue_7};
      font-size: ${theme.fontSizes.md};
      margin-left: 0.5rem;
      font-weight: 700;
    }
  }
`;

const UploadContentWrapper = styled.div`
  .upload {
    border: 1px solid ${theme.colors.gray_7};
    border-style: dotted;
  }

  .flex-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .icon {
    width: 256px;
    object-fit: cover;
  }
`;

const UploadWrapper = styled.div`
  display: flex;
  padding-top: 20px;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  .emptyImage {
    border: 1px solid ${theme.colors.dark_100};
    border-radius: 4px;
    border-style: dotted;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 24px;

    & > * + * {
      margin-top: 10px;
    }

    cursor: pointer;
  }

  .turText {
    font-size: ${theme.fontSizes.sm};
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    margin-top: 8px;
  }

  .emptyImageText {
    color: ${theme.colors.dark_500};
    font-size: ${theme.fontSizes.normal};
    font-weight: ${theme.fontWeights.normal};
    line-height: 24px;
    letter-spacing: 0.2px;
  }

  .uploadTotalWrap {
    display: flex;

    & > * + * {
      margin-left: 8px;
    }
  }

  & > * + * {
  }
`;

const AddButton = styled.div`
  margin-top: 26px;
  cursor: pointer;
  display: flex;
  align-items: center;

  & > * + * {
    margin-left: 6px;
  }

  p {
    color: ${theme.colors.blue_500};
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 24px;
    letter-spacing: 0.2px;
  }
`;
